module.exports = __webpack_public_path__ + "static/media/CircularStd-BoldItalic.b88d7b4e.woff2";